import React, {useState, useEffect} from 'react';
import axios from 'axios';
import validator from 'validator'
import moment from 'moment'
import { notify } from '../utils/ToastUtils';
import {useSelector} from 'react-redux'
import { selectUser } from 'src/stores/userSlice';
import SharedProfileForm from '../components/SharedProfileForm';

export const MyProfile = ({ onUploadImage, profileData, isUploadingImg, refreshProfile }) => {
	const [profile, setProfile] = useState({})
		const [isDisabled, setIsDisabled] = useState(false)
	const [checked, setChecked] = useState(false);
	const [editable, setEditable] = useState(false)
	const [emailError, setEmailError] = useState('')
	const [timestamp, setTimestamp] = useState(Date.now())
	const user = useSelector(selectUser)
	
	const initialState = {
		firstName:'',
		lastName:'',
		fatherName:'',
		phone:'',
		bloodGrp:'',
		dob:'',
		originalDob:'',
		addrLine1:'',
		addrLine2:'',
		city:'',
		empstate:'',
		pincode:'',
		email:'',
		contactNo:'',
		aadharNo:'',
		panNo:'',	
		nameAsBank:'',
		bank:'',
		accountNo:'',
		ifsc:'',
		uanPF:'',
		manager:'',
		status:'',
		designation:'',
		doj: '',
		dataAcesMail: '',
		location: ''
	}
	const [state, setState] = useState(initialState)
	const [remote, setRemote] = useState('No')

	const updateProfile = async () => {
		if(profile?.ALLOW_EDIT === "No"){
			notify.error("Please reach out to manager to update details")
		} else {		
			if(state.firstName && state.lastName && state.fatherName && state.phone && state.bloodGrp && state.dob && state.addrLine1 && state.addrLine2 && state.city && state.pincode && state.email && state.contactNo && remote && state.aadharNo && state.panNo && state.nameAsBank && state.bank && state.accountNo && state.ifsc && state.uanPF){
				if(checked === true){
					setIsDisabled(true)
					try{
						await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateBio`,{
							empcode:user?.emp_code,
							empName:state.firstName+" "+state.lastName,
							fatherName:state.fatherName,
							phone:state.phone,
							bloodGrp:state.bloodGrp,
							dob:state.dob,
							originalDob:state.originalDob,
							addrLine1:state.addrLine1,
							addrLine2:state.addrLine2,
							city:state.city,
							pincode: state.pincode,
							location: (profile?.EMP_LOCATION),
							doj:state.doj,
							email:state.email,
							contactNo:state.contactNo,
							aadharNo:state.aadharNo,
							panNo:state.panNo,
							nameAsBank:state.nameAsBank,
							bank:state.bank,
							accountNo:state.accountNo,
							ifsc:state.ifsc,
							uanPF:state.uanPF,
							remote,
							lastUpdatedDt:moment(new Date()).format("YYYY-MM-DD"),
							isManager:user?.is_admin,
						})
						notify.success("Profile updated successfully")	
						setIsDisabled(false)
						if (refreshProfile) refreshProfile()
					}catch(error){				
						setIsDisabled(false)
						let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
						notify.error(errmsg)
					}	
				} else notify.error("Please select the checkbox")	 
			} else {
				notify.error("All fields are mandatory for the profile update")
			}
		}				
	}

	useEffect(()=>{
		if(profileData) {
			setTimestamp(Date.now())
			setProfile(profileData)
			setRemote(profileData?.REMOTE_EMPLOYEE)
			setState({
				firstName:(profileData?.EMP_NAME)?.split(' ')[0] || '',
				lastName:(profileData?.EMP_NAME)?.substr(profileData?.EMP_NAME.indexOf(" ") + 1) || '',
				fatherName:profileData?.EMP_FATHERS_NAME || '',
				phone:profileData?.EMP_MOBILE_NO || '',
				bloodGrp:profileData?.EMP_BLOOD_GROUP || '',
				dob:profileData?.EMP_DATE_OF_BIRTH ? moment(profileData?.EMP_DATE_OF_BIRTH).format("YYYY-MM-DD") : '',
				originalDob:profileData?.ORIGINAL_DOB ? moment(profileData?.ORIGINAL_DOB).format("YYYY-MM-DD") : "",
				doj:profileData?.EMP_DATE_OF_JOIN ? moment(profileData?.EMP_DATE_OF_JOIN).format("YYYY-MM-DD") : '',
				addrLine1:profileData?.EMP_ADDRESS_1 || '',
				addrLine2:profileData?.EMP_ADDRESS_2 || '',
				city:profileData?.EMP_CITY || '',
				empstate:profileData?.EMP_STATE || '',
				pincode:profileData?.PINCODE || '',
				location:profileData?.EMP_LOCATION || '',
				dataAcesMail:profileData?.EMP_WORK_EMAIL || '',
				email:profileData?.EMP_PERSONAL_EMAIL || '',
				contactNo:profileData?.EMERGENCY_CONTACT_NO || '',
				aadharNo:profileData?.EMP_AADHAR_NO || '',
				panNo:profileData?.EMP_PAN_NO || '',	
				nameAsBank:profileData?.EMP_NAME_AS_IN_BANK || '',
				bank:profileData?.EMP_BANK_NAME || '',
				accountNo:profileData?.EMP_ACCOUNT_NO || '',
				ifsc:profileData?.EMP_IFSC_NO || '',
				uanPF:profileData?.EMP_PF_NO || '',
				designation: profileData?.DESIGNATION || '',
				status:profileData?.EMP_STATUS || '',
				manager:profileData?.REPORTING_MANAGER_ID || '',				
			})			
			let editFlag = (profileData?.ALLOW_EDIT === "No") ? true : false
			setEditable(editFlag)
			setChecked(editFlag)
		}
	},[profileData])

	const handleCheckBoxChange = (event) => {
		setChecked(event.target.checked);
	};

	function handleChange(evt) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
		if(evt.target.name === "email"){
            if (validator.isEmail(value)) {            
                setEmailError('Valid')
            } else {
                setEmailError('Enter valid Email!')
            }
        } 
		if(evt.target.name === "remote"){
          setRemote(evt.target.value)
        }
    }

	
	
	return (
		<SharedProfileForm 
			isUS={false}
			state={{...state, remote}}
			handleChange={(evt) => {
				if (evt.target.name === 'remote') setRemote(evt.target.value);
				else handleChange(evt);
			}}
			handleCheckBoxChange={handleCheckBoxChange}
			checked={checked}
			updateProfile={updateProfile}
			editable={editable}
			emailError={emailError}
			isLoading={isDisabled}
			userSummary={{
				avatar: profile?.IMG_PATH ? `${process.env.REACT_APP_PUBLIC_URL}/${profile?.IMG_PATH}?t=${timestamp}` : null,
				name: state.firstName + ' ' + state.lastName,
				designation: state.designation,
				empId: profile?.EMP_ID,
				location: profile?.EMP_LOCATION || '-',
				status: state.status,
				doj: state.doj ? moment(state.doj).format('DD MMM YYYY') : '-',
				manager: state.manager,
				workEmail: state.dataAcesMail
			}}
			onUploadImage={onUploadImage}
			isUploadingImg={isUploadingImg}
			isProfileView={true}
		/>
	)
}

export default MyProfile;
